exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.errorDisplay{padding-top:10px;padding-bottom:10px;background:transparent;border:none;color:#da3956;margin:0;list-style:none;text-align:left}div.errorDisplay ul{padding-left:0}div.errorDisplay li{list-style:none}div.errorDisplay .closeLink{float:right;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/error_display.scss
// module id = 1472
// module chunks = 0